import React from 'react'

/** 为 true 时，流程编辑器中的 NodeFieldPreview 禁用公式（自动化与子流程）。 */
export const WorkflowNodeFieldFormulaContext = React.createContext<boolean | undefined>(undefined)
